function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var DiplomacyTemplate = require('./diplomacy.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var DiplomacyOverlay = /*#__PURE__*/function () {
  function DiplomacyOverlay(app, mod) {
    _classCallCheck(this, DiplomacyOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
    this.overlay.clickBackdropToClose = false;
    this.faction = '';
    this.faction_under_offer = '';
    this.active_proposal = -1;
    this.is_visible = false;
    this.proposals = [];
    this.proposal = {};
    this.proposal.confirms = [];
    this.proposal.terms = [];
    this.proposal.parties = [];
    this.proposal.proposer = '';
    this.proposal.target = '';
    this.game_menu_zindex = 0;
  }
  return _createClass(DiplomacyOverlay, [{
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "purgeProposals",
    value: function purgeProposals() {
      this.proposals = [];
      this.proposal = {};
      this.proposal.confirms = [];
      this.proposal.terms = [];
      this.proposal.parties = [];
      this.proposal.proposer = '';
      this.proposal.target = '';
    }
  }, {
    key: "hide",
    value: function hide() {
      this.purgeProposals();
      this.is_visible = false;
      this.overlay.hide();
      var gm = document.querySelector('#saito-header');
      if (this.game_menu_zindex > 0) {
        if (gm) {
          gm.style.zIndex = this.game_menu_zindex;
        }
      }
      return;
    }
  }, {
    key: "render",
    value: function render() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var his_self = this.mod;
      this.is_visible = true;
      var num = 0;
      this.active_proposal = -1;
      var gm = document.querySelector('#saito-header');
      if (gm) {
        this.game_menu_zindex = gm.style.zIndex;
        gm.style.zIndex = 999;
      }
      if (faction == '') {
        faction = this.faction;
      } else {
        this.faction = faction;
      }
      if (faction != '' && !this.proposal.parties.includes(faction)) {
        this.proposal.parties.push(faction);
      }
      this.overlay.show(DiplomacyTemplate(this, faction));
      this.renderAllProposals(faction);
      var obj = document.querySelector('.diplomacy-overlay');
      if (obj) {
        obj.style.flexWrap = 'nowrap';
      }
      if (obj) {
        obj.style.background = '';
      }
      if (faction == 'hapsburg' || faction == 'england' || faction == 'france' || faction == 'papacy' || faction == 'protestants') {
        document.querySelector('.controls2 ul li.hapsburg').remove();
      }
      if (faction == 'england' || faction == 'france' || faction == 'papacy' || faction == 'protestants') {
        document.querySelector('.controls2 ul li.england').remove();
      }
      if (faction == 'france' || faction == 'papacy' || faction == 'protestants') {
        document.querySelector('.controls2 ul li.france').remove();
      }
      if (faction == 'papacy' || faction == 'protestants') {
        document.querySelector('.controls2 ul li.papacy').remove();
      }
      this.pushHudUnderOverlay();
      this.overlay.show();
      this.attachEvents(faction);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      //
      // delete proposals
      //
      document.querySelectorAll('.proposal-close').forEach(function (el) {
        el.onclick = function (e) {
          _this.proposals.splice(e.currentTarget.id, 1);
          _this.render(faction);
        };
      });

      //

      //
      // add terms to existing proposal
      //
      document.querySelectorAll('.proposal-add-term').forEach(function (el) {
        el.onclick = function (e) {
          _this.proposal.terms = _this.proposals[e.currentTarget.id].terms;
          _this.proposal.target = _this.proposals[e.currentTarget.id].target;
          _this.proposals.splice(e.currentTarget.id, 1);
          _this.renderAddProposalMenu(faction, _this.proposal.target);
        };
      });

      //
      // finish diplomacy stage
      //
      if (document.querySelector('.submit')) {
        document.querySelector('.submit').onclick = function (e) {
          for (var z = 0; z < _this.proposals.length; z++) {
            _this.mod.addMove('diplomacy_submit_proposal\t' + JSON.stringify(_this.proposals[z]));
          }
          _this.mod.endTurn();
          _this.hide();
        };
      }
      if (document.querySelector('.option.hapsburg')) {
        document.querySelector('.option.hapsburg').onclick = function (e) {
          _this.faction_under_offer = 'hapsburg';
          _this.createNewProposal(faction, 'hapsburg');
        };
      }
      if (document.querySelector('.option.protestant')) {
        document.querySelector('.option.protestant').onclick = function (e) {
          _this.faction_under_offer = 'protestant';
          _this.createNewProposal(faction, 'protestant');
        };
      }
      if (document.querySelector('.option.papacy')) {
        document.querySelector('.option.papacy').onclick = function (e) {
          _this.faction_under_offer = 'papacy';
          _this.createNewProposal(faction, 'papacy');
        };
      }
      if (document.querySelector('.option.england')) {
        document.querySelector('.option.england').onclick = function (e) {
          _this.faction_under_offer = 'england';
          _this.createNewProposal(faction, 'england');
        };
      }
      if (document.querySelector('.option.france')) {
        document.querySelector('.option.france').onclick = function (e) {
          _this.faction_under_offer = 'france';
          _this.createNewProposal(faction, 'france');
        };
      }

      //
      // submit
      //
      document.querySelector('.submit').onclick = function (e) {
        _this.submitProposals();
      };
      return;
    }
  }, {
    key: "renderAllProposals",
    value: function renderAllProposals() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var any_proposals = false;
      var proposals_html = '<ol>';
      for (var i = 0; i < this.proposals.length; i++) {
        any_proposals = true;
        proposals_html += '<li class="proposal-group-level">';
        proposals_html += "<div><div class=\"proposal-target-faction\">Offer to ".concat(this.mod.returnFactionName(this.proposals[i].target), "<div class=\"proposal-close\" id=\"").concat(i, "\">X</div></div><ul>");
        var p = this.proposals[i];
        var t = this.mod.convertTermsToText(p.terms);
        for (var z = 0; z < t.length; z++) {
          proposals_html += '<li class="proposal-term-level">' + t[z] + '</li>';
        }
        proposals_html += "<li class=\"proposal-term-level proposal-add-term\" id=\"".concat(i, "\">add new term</li>");
        proposals_html += '</ul></div></li>';
      }
      proposals_html += '</ol>';
      if (any_proposals) {
        document.querySelector('.diplomacy-overlay .right .proposals').innerHTML = proposals_html;
        try {
          var sobj = document.querySelector('.submit');
          if (sobj) {
            sobj.innerHTML = 'submit offers';
          }
        } catch (err) {}
      }
    }
  }, {
    key: "createNewProposal",
    value: function createNewProposal() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.terms = [];
      this.proposal.target = target;
      this.renderAddProposalMenu(faction, target);
    }
  }, {
    key: "submitProposals",
    value: function submitProposals() {
      for (var z = 0; z < this.proposals.length; z++) {
        this.mod.addMove('diplomacy_submit_proposal\t' + JSON.stringify(this.proposals[z]));
      }
      this.mod.endTurn();
      this.hide();
    }
  }, {
    key: "renderAddProposalMenu",
    value: function renderAddProposalMenu(faction) {
      var _this2 = this;
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var his_self = this.mod;
      var obj = document.querySelector('.diplomacy-overlay');
      if (obj) {
        obj.style.flexWrap = 'wrap';
      }
      if (obj) {
        obj.style.background = 'transparent';
      }

      //
      // overlay gets menu
      //
      var menu = this.mod.returnDiplomacyMenuOptions(this.mod.game.player, faction);
      var html = '';
      for (var i = 0; i < menu.length; i++) {
        if (menu[i].check(his_self, his_self.game.player, faction, target)) {
          html += this.returnMenuHTML(menu[i].name, menu[i].img, i);
        }
      }
      document.querySelector('.diplomacy-overlay').innerHTML = html;

      //
      // attach interactivity
      //
      for (var _i = 0; _i < menu.length; _i++) {
        var _obj = document.querySelector(".menu-option-container".concat(_i));
        if (_obj) {
          _obj.onclick = function (e) {
            //
            // hide in overlay function to avoid purging proposals
            //
            _this2.overlay.hide();
            _this2.pullHudOverOverlay();

            //
            // manipulate proposal list
            //
            var id = e.currentTarget.id;
            menu[id].fnct(his_self, faction, function (terms) {
              for (var z = 0; z < terms.length; z++) {
                var io = _this2.mod.returnDiplomacyImpulseOrder(faction);
                for (var y = 0; y < io.length; y++) {
                  if (terms[z].indexOf(io[y]) > -1 && !_this2.proposal.parties.includes(io[y])) {
                    _this2.proposal.parties.push(io[y]);
                  }
                  if (terms[z].indexOf('marital') > -1 && !_this2.proposal.parties.includes('papacy') && io[y] == 'papacy') {
                    _this2.proposal.parties.push('papacy');
                  }
                  if (terms[z].indexOf('marriage') > -1 && !_this2.proposal.parties.includes('papacy') && io[y] == 'papacy') {
                    _this2.proposal.parties.push('papacy');
                  }
                }
                _this2.proposal.terms.push(terms[z]);
              }

              //
              // add proposal to stack and reclaim
              //
              _this2.proposal.proposer = _this2.faction;
              _this2.proposals.push(_this2.proposal);
              _this2.proposal = {};
              _this2.proposal.terms = [];
              _this2.proposal.parties = [];
              _this2.proposal.proposer = _this2.faction;

              //
              // and re-render
              //
              _this2.render(faction);
            });
          };
        }
      }
    }
  }, {
    key: "returnMenuHTML",
    value: function returnMenuHTML() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var img = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var idx = arguments.length > 2 ? arguments[2] : undefined;
      var active_option = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'active card';
      return "\n              <div id=\"".concat(idx, "\" class=\"menu-option-container").concat(idx, " menu-option-container ").concat(active_option, "\">\n                <div class=\"menu-option-image\">\n                  <img src=\"/his/img/backgrounds/diplomacy/").concat(img, "\" />\n                </div>\n                <div class=\"menu-option-title\">").concat(name, "</div>\n              </div>\n          ");
    }
  }]);
}();
module.exports = DiplomacyOverlay;